import React from "react";
import { USBanner } from "../../../../Banner/Banner";
import { Helmet } from "react-helmet-async";
import studies from "./Studies";
import "./ClinicalStudies.css";
import ClinicalStudiesTile from "../../../../ClinicalStudiesTile/ClinicalStudiesTile";
import { cdn } from "../../../../../consts/cdn";
import { sendStudyLinkClick } from "../../../../../utilities/GoogleAnalyticsEvents";

//Images
const BannerDesktop = cdn.images + "ClinicalEvidence/Banner-Desktop.jpg";
const BannerMobile = cdn.images + "ClinicalEvidence/Banner-Mobile.jpg";

export const ClinicalStudies = () => {
  const handleStudyClick = (title, url) => {
    sendStudyLinkClick(title, url);
    window.open(url, "_blank");
  };

  return (
    <div className="clinicalstudies">
      <Helmet>
        <title>
          vNOTES – Advanced Minimally Invasive Gynecologic Procedures
        </title>
        <link rel="canonical" href="https://www.vnotes.com/clinicalevidence" />
        <meta
          name="description"
          content="vNOTES (vaginal natural orifice transluminal endoscopic surgery) workshops provide a comprehensive understanding of procedural steps and instrumentation used…"
        />
      </Helmet>
      <USBanner
        imgdesktop={BannerDesktop}
        imgmobile={BannerMobile}
        bold1="CLINICAL EVIDENCE"
        color="#365B7E"
      />
      <div className="content">
        {studies.map((study, index) => {
          return (
            <ClinicalStudiesTile
              key={`study-${index}`}
              header={study.header}
              date={study.date}
              studyurl={study.studyurl}
              title={study.title}
              doctors={study.doctors}
              content={study.content}
              uniqueid={index}
              onExternalLinkClick={() =>
                handleStudyClick(study.title, study.studyurl)
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default ClinicalStudies;
